import React from "react";
import { Container, Row, Col, Card, Image, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Carousel, Modal } from "react-bootstrap";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import SocialBar from "../components/SocialBar";
import ComiteEventos from "../components/ComiteEventos";
import { useSiteSettings } from '../hooks/useSiteSettings';
import { useCommittee } from '../hooks/useCommittee';
import fallbackBanner from '../assets/imagen.jpg';
import juventudImg from "../assets/fotos/juventud_logo.png";
import "../components/comiteJuventud.css";
import SocialComite from "../components/socialComite";

import img1 from "../assets/juventud/1.jpg";
import img2 from "../assets/juventud/2.jpg";
import img3 from "../assets/juventud/3.jpg";
import img4 from "../assets/juventud/4.jpg";
import img5 from "../assets/juventud/5.jpg";

const galleryFallback = [img1, img2, img3, img4, img5];

export default function ComiteJuventud() {
  const { settings } = useSiteSettings();
  const bannerSrc = settings.banner_image
    ? `https://facach.coop.hn${settings.banner_image}`
    : fallbackBanner;

  const { data: comite } = useCommittee('juventud');

  const [showModal, setShowModal]         = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [currentIndex, setCurrentIndex]   = React.useState(0);

  const logoSrc = comite?.logo_url || juventudImg;
  const galleryImages = comite?.gallery?.length > 0
    ? comite.gallery.map(g => g.image_url)
    : galleryFallback;

  const handleOpenModal = (index) => {
    setSelectedImage(galleryImages[index]);
    setCurrentIndex(index);
    setShowModal(true);
  };
  const handleNext = () => {
    const i = (currentIndex + 1) % galleryImages.length;
    setCurrentIndex(i); setSelectedImage(galleryImages[i]);
  };
  const handlePrev = () => {
    const i = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentIndex(i); setSelectedImage(galleryImages[i]);
  };

  return (
    <>
      <NavbarFacach />
      <div className="comite-page">
        <div className="banner-wrapper">
          <Image src={bannerSrc} alt="..." fluid className="banner-image" />
          <div className="banner-overlay">
            <h1 className="banner-title">{comite?.banner_title || 'COMITÉ DE JUVENTUD'}</h1>
          </div>
        </div>
        <br />

        <Container className="pb-2">
          <Row className="align-items-start g-4">
            <Col md={8}>
              <h2 className="section-title">{comite?.intro_title || '¿Quiénes Somos?'}</h2>
              <p className="comite-intro">{comite?.intro_text || 'El Comité de Juventud es órgano auxiliar de la Junta Directiva...'}</p>
            </Col>
            <Col md={4}>
              <div className="thumb-wrap">
                <Image src={logoSrc} alt="Logo Comité Juventud" fluid className="thumb-image" />
              </div>
            </Col>
          </Row>
        </Container>

        <Container className="py-4">
          <h2 className="section-title">{comite?.responsibilities_title || 'Responsabilidades del Comité de Juventud'}</h2>
          <Row className="g-4 pt-2">
            {comite?.responsibilities?.length > 0 ? (
              comite.responsibilities.map(resp => (
                <Col md={4} key={resp.id}>
                  <Card className="resp-card h-100 shadow-sm">
                    <Card.Body>
                      <h6 className="resp-item-title">{resp.title}</h6>
                      <p className="resp-item-text">{resp.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <>
                <Col md={4}>
                  <Card className="resp-card h-100 shadow-sm">
                    <Card.Body>
                      <h6 className="resp-item-title">Capacitaciones</h6>
                      <p className="resp-item-text">Coordinar con el Comité de Educación las actividades de capacitación contempladas en su plan de trabajo.</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="resp-card h-100 shadow-sm">
                    <Card.Body>
                      <h6 className="resp-item-title">Encuentros de Juventud</h6>
                      <p className="resp-item-text">Promover y realizar junto a las Cooperativas base, campañas y encuentros nacionales.</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="resp-card h-100 shadow-sm">
                    <Card.Body>
                      <h6 className="resp-item-title">Participación</h6>
                      <p className="resp-item-text">Participación en espacios nacionales e internacionales previa aprobación de la Junta Directiva.</p>
                    </Card.Body>
                  </Card>
                </Col>
              </>
            )}
          </Row>

          <Container className="py-4">
            <h2 className="section-title mb-0">Noticias y Eventos</h2>
            <ComiteEventos committeeCode="juventud" limit={3} />
          </Container>

          <Container className="py-4">
            <h2 className="section-title">Galería</h2>
            <Row className="justify-content-center">
              <Col md={8}>
                <Carousel interval={3000} fade indicators={false}>
                  {galleryImages.map((img, idx) => (
                    <Carousel.Item key={idx}>
                      <Image src={img} fluid
                        style={{ cursor: "pointer", borderRadius: "10px" }}
                        onClick={() => handleOpenModal(idx)} />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </Col>
            </Row>
          </Container>

          <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg" contentClassName="modal-gallery-transparent">
            <Modal.Body className="text-center">
              <Image src={selectedImage} fluid style={{ borderRadius: "10px", maxHeight: "80vh" }} />
            </Modal.Body>
            <Button variant="light" onClick={handlePrev} style={{ position: "absolute", top: "50%", left: "20px", transform: "translateY(-50%)", borderRadius: "50%", opacity: 0.8 }}>‹</Button>
            <Button variant="light" onClick={handleNext} style={{ position: "absolute", top: "50%", right: "20px", transform: "translateY(-50%)", borderRadius: "50%", opacity: 0.8 }}>›</Button>
          </Modal>
          <SocialComite/>

          <div className="actions mt-4 d-flex gap-2">
            <Button variant="outline-primary" as={Link} to="/comitesMain">Volver a Comités por Ley</Button>
          </div>
        </Container>

        <SocialBar position="right" top="40%" size={42} rounded={true} />
        <FooterFacach />
      </div>
    </>
  );
}
